function cartLineName(title1: string | null | undefined, title2: string | null | undefined): string {
    return [title1, title2]
        .map(part => (part ?? '').trim())
        .filter(part => part.length > 0)
        .join(' ');
}

function withLineName(action: string, title1: string | null | undefined, title2: string | null | undefined, emptyLabel: string): string {
    const name = cartLineName(title1, title2);
    return name.length > 0 ? `${action} ${name}` : emptyLabel;
}

/** Accessible name for a line's quantity select or text box. The empty label stays the control's current name. */
export function cartChangeQuantityLabel(title1: string | null | undefined, title2: string | null | undefined, emptyLabel = 'Change quantity'): string {
    return withLineName('Change quantity of', title1, title2, emptyLabel);
}

export function cartDecreaseQuantityLabel(title1: string | null | undefined, title2: string | null | undefined, emptyLabel = 'Decrease quantity'): string {
    return withLineName('Decrease quantity of', title1, title2, emptyLabel);
}

export function cartIncreaseQuantityLabel(title1: string | null | undefined, title2: string | null | undefined, emptyLabel = 'Increase quantity'): string {
    return withLineName('Increase quantity of', title1, title2, emptyLabel);
}

export function cartQuantityGroupLabel(title1: string | null | undefined, title2: string | null | undefined, emptyLabel = 'Quantity'): string {
    return withLineName('Quantity of', title1, title2, emptyLabel);
}

/** Visible text is "Remove", so the name keeps that word and adds the line. */
export function cartRemoveLabel(title1: string | null | undefined, title2: string | null | undefined, emptyLabel = 'Remove product'): string {
    const name = cartLineName(title1, title2);
    return name.length > 0 ? `Remove ${name} from cart` : emptyLabel;
}

/** Icon-only edit pencil. The field name stays stable, and the line name keeps two of the same field apart. */
export function cartEditLabel(field: string | null | undefined, title1: string | null | undefined, title2: string | null | undefined, emptyField = 'details'): string {
    const what = (field ?? '').trim();
    const subject = what.length > 0 ? what : emptyField;
    const name = cartLineName(title1, title2);
    return name.length > 0 ? `Edit ${subject} for ${name}` : `Edit ${subject}`;
}
